import {
  AssinaturaType,
  FormularioSituacao,
  ID,
  Response,
} from '../../../../../../_metronic/helpers'
import { AtendimentoForm } from '../../../atendimento_medicos/atendimentos-medico-list/core/_models'
import { FormularioList } from '../../../formularios/formularios-list/core/_models'
import { PacienteList } from '../../../paciente-management/pacientes-list/core/_models'

export type FormularioAtendimentoList = {
  concluido: boolean
  respondido: boolean
  assinado: boolean
  cancelado: boolean
  dataFormatada: string
  atendimento: AtendimentoForm
  paciente: PacienteList
  situacao: FormularioSituacao
  formulario: FormularioList
  id: ID
  data: string
  /**
   * Interconsulta: é o formulário que o solicitante preenche e o teleconsultor responde e assina (o
   * vinculado ao tipo IC da empresa/unidade). Depois de uma réplica, as duas instâncias vêm marcadas.
   * `false` nos demais formulários e fora de interconsulta.
   */
  interconsulta?: boolean
}

export type FormularioAtendimentoDtoAssinatura = {
  atendimento: number
  formularioAtendimento: number
  senha?: string
  tipo: AssinaturaType
}

export type FormularioAtendimentoDtoAssinaturaLote = {
  formulariosAtendimento: number[]
  senha?: string
  tipo: AssinaturaType
}

export type IAvaliacoesSelect = {
  atendimentoId: ID
  formularioAtendimentoId: ID
}

export type ListViewContextPropsAvaliacoes = {
  isAllSelected?: boolean
  selected: Array<IAvaliacoesSelect>
  onSelect: (selectedId: IAvaliacoesSelect) => void
  clearSelected: () => void
  disabled?: boolean
  onSelectAll?: () => void
}

export const initialListViewAvaliacoes: ListViewContextPropsAvaliacoes = {
  selected: [],
  onSelect: () => {},
  clearSelected: () => {},
  disabled: false,
  isAllSelected: false,
  onSelectAll: () => {},
}

export type AvaliacoesQueryResponse = Response<Array<FormularioAtendimentoList>>
